<!-- =========================================================================================
  File Name: Create.vue
  Description: Partner Create Page
========================================================================================== -->


<template>
  <div id="apps-partners-create">

    <vx-card>

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Информация" icon-pack="feather" icon="icon-info">
            <div class="tab-text">
              <tab-information class="mt-4" :partner="partner_data" :programs="programs_data" />
            </div>
          </vs-tab>
          <vs-tab label="Контакты" icon-pack="feather" icon="icon-share-2">
            <div class="tab-text">
              <tab-contacts class="mt-4" :partner="partner_data" />
            </div>
          </vs-tab>
          <vs-tab label="Описание" icon-pack="feather" icon="icon-file-text">
            <div class="tab-text">
              <tab-description class="mt-4" :partner="partner_data" />
            </div>
          </vs-tab>
        </vs-tabs>

      </div>

    </vx-card>
  </div>
</template>

<script>
import TabInformation from "./TabInformation.vue"
import TabContacts     from "./TabContacts.vue"
import TabDescription      from "./TabDescription.vue"

// Store Module
import modulePartner from '@/store/partner/modulePartner.js'

export default {
  components: {
    TabInformation,
    TabContacts,
    TabDescription,
  },
  data() {
    return {
      partner_data: { state: 0, program: 1 },
      activeTab: 0,
    }
  },
  computed: {
    programs_data() {
      return this.$store.state.partner.programs
    },

  },
  watch: {
    activeTab() {
    }
  },
  methods: {
  },
  created() {
    if (!modulePartner.isRegistered) {
      this.$store.registerModule('partner', modulePartner)
      modulePartner.isRegistered = true
    }
    this.$store.dispatch("partner/fetchPrograms")
  }
}

</script>
